module.exports = __webpack_public_path__ + "img/card-2a-report.849ae0b5.svg";